import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
import { useTranslation, useProperty, useSiteContext } from '@eti/providers';
import { useEffect, useState } from 'react';
import { getBrandedBanners } from '../utils/utils';

const bannerImageStyles = css`
  height: auto;
  width: 100%;
`;

type BannersType = {
  desktop: string;
  tablet: string;
  mobile: string;
};

const Banners = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const {
    brand,
    language: { code: language },
  } = useSiteContext();
  const brandedBannerLink = p('Order.BrandedBanner.Link');
  const [banners, setBanners] = useState<BannersType | null>(null);

  useEffect(() => {
    getBrandedBanners(brand.code, language)
      .then((b) => {
        setBanners(b);
      })
      .catch(() => {
        setBanners(null);
      });
  }, [brand, language]);

  if (!banners || !brandedBannerLink) {
    return null;
  }

  return (
    <a data-testid="banner-image-link" href={brandedBannerLink} rel="noreferrer" target="_blank">
      <picture data-testid={`banner-image-language-${language}`}>
        <source
          media={`(min-width:${breakpoints._768})`}
          srcSet={banners.desktop}
          type="image/webp"
        />
        <source
          media={`(min-width:${breakpoints._560})`}
          srcSet={banners.tablet}
          type="image/webp"
        />
        <img
          alt={`${brand.name} ${t('OrderDetails.HotelAndCar.Hotels.Title')}`}
          className={bannerImageStyles}
          data-testid="banner-image"
          src={banners.mobile}
        />
      </picture>
    </a>
  );
};

export default Banners;
